// @ts-nocheck
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux";
import { logoutUser } from "../../store/userSlice";
import {
  fetchCoachPublicProfile,
  updateProfilePicture,
} from "../../store/postsSlice";
import { BASE_URL } from "../../Constants/BaseUrl";
import ContentLoader, { Rect } from "react-content-loader";
import SkeletonLoader from "../../components/SkeletonLoader";
import { MoreVertical } from "lucide-react";
import BlockUserModal from "../../components/BlockUserModal";
import useHandleChat from "../../hooks/useHandleChat";

const CoachPublicProfile = () => {
  const [profilePicLoading, setProfilePicLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const dispatch = useAppDispatch();
  const { userPosts, loading, error } = useAppSelector((state) => state.posts);
  const navigate = useNavigate();
  const location = useLocation();
  console.log("coach id: ", location.state.user_id);
  const userDetails = useAppSelector((state) => state.posts.coachPublicProfile);
  const user = useAppSelector((state) => state.user);
  const [isChatLoading, setIsChatLoading] = useState(false);

  const handleChat = useHandleChat(user, userDetails, setIsChatLoading);

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  useEffect(() => {
    if (location.state.user_id) {
      dispatch(fetchCoachPublicProfile(location.state.user_id));
    }
  }, [dispatch, location.state.user_id]);

  const handleBlockUser = () => {
    setShowBlockModal(true);
    setShowDropdown(false);
  };

  const handleModalClose = () => {
    setShowBlockModal(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen p-4 bg-black text-white">
        <SkeletonLoader />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 bg-black text-white">
      {/* Header */}
      <div className="relative flex flex-col items-center py-6">
        <div className="relative w-full flex justify-center">
          <img
            // src={
            //   userDetails?.profile_picture
            //     ? `${BASE_URL}/${userDetails.profile_picture}`
            //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            // }
            src={
              userDetails?.profile_picture?.startsWith("https")
                ? userDetails.profile_picture
                : userDetails?.profile_picture
                  ? `${BASE_URL}/${userDetails.profile_picture}`
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            }
            alt="Profile"
            className="w-36 h-36 rounded-full border-2 border-white mb-4 object-cover"
          />
          {/* More option */}
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="absolute right-0 top-0 text-white hover:text-gray-300"
          >
            <MoreVertical className="w-8 h-8" />
          </button>
        </div>
        {/* Dropdown Menu */}
        {showDropdown && (
          <div className="absolute top-12 right-3 bg-gray-900 border border-gray-700 rounded-md shadow-lg z-10">
            <button
              onClick={handleBlockUser}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-800"
            >
              Block User
            </button>
          </div>
        )}
        <div className="text-center">
          <h2 className="text-xl font-semibold text-white">
            {userDetails?.coach_info?.first_name}{" "}
            {userDetails?.coach_info?.last_name}
          </h2>
          <p className="text-md text-white mt-1">
            {userDetails?.coach_info?.college}
          </p>
          <p className="text-md text-white mt-1">
            {userDetails?.coach_info?.sport_name}
          </p>
          <div className="flex justify-center gap-12 mt-4">
            <div className="text-center">
              <p className="text-lg font-semibold text-white">0</p>
              <p className="text-sm text-white">Followers</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-semibold text-white">0</p>
              <p className="text-sm text-white">Following</p>
            </div>
          </div>
          <div className="flex justify-center gap-6 mt-4 w-full">
            {/* <button
              className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 transition w-32"
              onClick={() => alert("In Progress")}
            >
              Follow
            </button> */}
            <button
              onClick={handleChat}
              disabled={isChatLoading}
              className={`px-6 py-2 rounded bg-[#666666] text-white text-sm hover:bg-gray-700 mt-5 ${
                isChatLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isChatLoading ? "Loading..." : "Message"}
            </button>
          </div>
        </div>
      </div>
      <BlockUserModal
        visible={showBlockModal}
        onClose={handleModalClose}
        userId={location.state?.user_id}
      />

      {/* Posts Grid */}
      <div className="grid grid-cols-3 gap-2 mt-10">
        {userDetails?.posts?.length === 0 ? (
          <div className="col-span-3 flex justify-center items-center mt-12">
            <p className="text-lg text-white">No posts yet.</p>
          </div>
        ) : (
          userDetails?.posts?.map((item) => {
            if (!item) return null;
            // const imageUrl = item.image_url
            //   ? `${BASE_URL}${item.image_url}`
            //   : null;
            // const videoUrl = item.video_url
            //   ? `${BASE_URL}${item.video_url}`
            //   : null;
            const imageUrl = item.image_url?.startsWith("https")
              ? item.image_url
              : item.image_url
                ? `${BASE_URL}/${item.image_url}`
                : null;

            const videoUrl = item.video_url?.startsWith("https")
              ? item.video_url
              : item.video_url
                ? `${BASE_URL}/${item.video_url}`
                : null;
            if (!imageUrl && !videoUrl) return null;

            return (
              <div
                key={item.post_id}
                className="relative aspect-square overflow-hidden rounded-md cursor-pointer"
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt="Post"
                    className="w-full h-full object-cover"
                    onClick={() =>
                      navigate("/post-preview", {
                        state: {
                          currentPost: item,
                          posts: userDetails?.posts,
                        },
                      })
                    }
                  />
                ) : (
                  <video
                    src={videoUrl}
                    className="w-full h-full object-cover"
                    onClick={() =>
                      navigate("/post-preview", {
                        state: {
                          currentPost: item,
                          posts: userDetails?.posts,
                        },
                      })
                    }
                  />
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default CoachPublicProfile;
